import React, { useState } from 'react';
import { Container, Backdrop } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AppBar from '../AppBar';
import Drawer from '../Drawer';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  const toggleDrawer = (open: boolean) => {
    setDrawerOpen(open);
  };

  const handleSearchToggle = () => {
    setSearchVisible(!searchVisible);
  };

  const handleSearchBlur = () => {
    setSearchVisible(false);
  };

  return (
    <>
      <AppBar onMenuClick={() => toggleDrawer(true)} />
      <Drawer isOpen={isDrawerOpen} onClose={() => toggleDrawer(false)} />
      <Container maxWidth={false} sx={{ mt: 4 }}>
        {children}
      </Container>
    </>
  );
};

export default MainLayout;